import FavoriteBrands from 'components/Brand/BrandsList/FavoriteBrands/FavoriteBrands';

export default FavoriteBrands;
